export type ApiErrorOrigin = 'graphql' | 'http' | 'session';

type ApiErrorInit = {
  message: string;
  origin: ApiErrorOrigin;
  status?: number;
  code?: string;
  operation?: string;
  cause?: unknown;
};

/**
 * Erro de toda chamada do módulo. `status` e `code` ficam no topo porque é o que o `shouldRetryQuery`
 * de `queryClient/` lê. `code` é o `extensions.code` no GraphQL e o `reason` do `SessionError` na sessão;
 * `operation` é o `operationName` no GraphQL e o método com a URL no REST.
 */
export class ApiError extends Error {
  override readonly name = 'ApiError';
  readonly origin: ApiErrorOrigin;
  readonly status: number | undefined;
  readonly code: string | undefined;
  readonly operation: string | undefined;

  constructor({ message, origin, status, code, operation, cause }: ApiErrorInit) {
    super(message, { cause });
    this.origin = origin;
    this.status = status;
    this.code = code;
    this.operation = operation;
  }
}
